'use client';

import { CSSProperties } from 'react';

import { styled } from '../../styles';

import 'react-datepicker/dist/react-datepicker.css';

export const DateRangePickerContainer = styled('div')(({ theme }) => ({
  width: '100%',

  '& .react-datepicker': {
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.surface2,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow:
      '0px 3px 14px 2px rgba(0, 0, 0, 0.06), 0px 8px 10px 1px rgba(0, 0, 0, 0.08), 0px 5px 5px -3px rgba(0, 0, 0, 0.15)',
    ...(theme.typography.label1 as CSSProperties),
    color: theme.palette.text2,

    '&-wrapper': {
      width: '100%',
    },

    '&__header': {
      backgroundColor: theme.palette.surface2,
      padding: theme.spacing(0),
      margin: theme.spacing(0),
      marginTop: theme.spacing(7),
      border: 'none',
      borderRadius: theme.spacing(0),
    },

    '&__day-names': {
      display: 'flex',
      padding: theme.spacing(0),
      margin: theme.spacing(0),
    },

    '&__month': {
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },

    '&__week': {
      display: 'flex',
      flexWrap: 'nowrap',
    },

    '&__day, &__day-name': {
      width: '45px !important',
      height: '36px !important',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: theme.spacing(0),
      padding: theme.spacing(0),
      border: '1px solid transparent !important',
      borderRadius: theme.spacing(0),
      backgroundColor: 'transparent !important',
      color: theme.palette.text2,
      outline: 'none',
      overflow: 'hidden',
    },

    '&__day-name': {
      height: 40,
      color: theme.palette.text3,
    },

    '&__day': {
      '&:not(&--outside-month):not(&--disabled):hover': {
        borderRadius: theme.spacing(0),
        backgroundColor: 'transparent',
        border: `1px solid ${theme.palette.divider} !important`,
        color: theme.palette.text2,
      },

      '&--today:not(&--outside-month)': {
        borderRadius: theme.spacing(0),
        backgroundColor: 'transparent',
        border: `1px solid ${theme.palette.primary.main} !important`,
        color: theme.palette.primary.main,
        fontWeight: 'normal',
      },

      '&--in-selecting-range:not(&--outside-month)': {
        borderRadius: theme.spacing(0),
        backgroundColor: 'transparent',
        border: `1px solid ${theme.palette.divider} !important`,
        borderLeftWidth: 0.5,
        borderRightWidth: 0.5,
        color: theme.palette.text2,
      },

      '&--in-range:not(&--outside-month):not(&--range-start):not(&--range-end)':
        {
          backgroundColor: `${theme.palette.surface4} !important`,
        },

      '&--range-start, &--range-end': {
        background: `${theme.palette.primary.main} !important`,
        color: `${theme.palette.textWhite} !important`,
        border: '1px solid transparent !important',

        '&:hover': {
          color: `${theme.palette.textWhite} !important`,
          border: '1px solid transparent !important',
        },
      },

      '&--outside-month, &--disabled': {
        pointerEvents: 'none',
        backgroundColor: 'transparent !important',
        opacity: 0.5,
      },
    },
  },
}));
